import React, {useState, useEffect} from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlignLeft } from "@fortawesome/free-solid-svg-icons"; 
import {Link, useNavigate} from "react-router-dom";
import Rightbar from './Rightbar';
import ImageUploading from 'react-images-uploading';
import ToggleButton from 'react-bootstrap/ToggleButton'
import { Form, Button, Row, Col, ListGroup, Table, ButtonGroup } from "react-bootstrap";
import { useSelector} from 'react-redux';
import { useParams } from "react-router";
import {artworkCreate} from '../../Service';
import {listArtworkByEvent,artworkupdate} from '../../Service';
import ClipLoader from "react-spinners/ClipLoader";

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  borderColor: "#96D2CE",
};


export default function Uploadartwork() {
    const [sidebar, setsidebar] = useState(false);
    const [mainbar, setmainbar] = useState(false);
    const toggle = () => {
        setsidebar(!sidebar);
        setmainbar(!mainbar);
    }
    const [checked, setChecked] = useState(false);
    const [radioValue, setRadioValue] = useState('1');
    const [loading, setLoading] = useState(false);
    const [color, setColor] = useState("#ffffff");
    
    const radios = [
    { name: 'INCHES', value: '1' },
    { name: 'CENTIMETERS', value: '2' }
    ];

  
    
    // my code ref
    const navigation = useNavigate();
    const loggedUser = useSelector(store => store.user['user'])
    let user_id = '';
    if(loggedUser){
      user_id = loggedUser.id
    }
    const [list, setList] = useState([]);
    const [formValues, setFormValues] = useState([]);
    const [formUpdateValues, setFormUpdatVealues] = useState([]);
    const [formErrors, setFormErrors] = useState({});
    const { id } = useParams();
    const event_id  = id;
    const [show, setShow] =useState({});

    const [editlist, setEditList] = React.useState([]);

    const [message, setMessage] = useState('');
    const [date, setDate] = useState(new Date());
    /*const [images, setImages] = React.useState([]);
    const [images2, setImages2] = React.useState([]);
    const [images3, setImages3] = React.useState([]);
    const [images4, setImages4] = React.useState([]);
    const [images5, setImages5] = React.useState([]);
    const [images6, setImages6] = React.useState([]);
    const [imageBinary, setimagesBinary] = useState('');*/

    
   
    const maxNumber = 69;

    useEffect(() => {
      var userDataForm = new FormData();
      userDataForm.append('user_id', user_id);
      userDataForm.append('event_id', event_id);
      listArtworkByEvent(userDataForm).then(res => setHandleExhibitorResponse(res))
    },[]);

    const setHandleExhibitorResponse = (res) => 
    {
        setList(res.data.data.items);
        setEditList(res.data.data.items);
        setFormValues(res.data.data.items);
    }

    /*const onChange = (imageList, addUpdateIndex) => {
        setImages(imageList);
        console.log('Images List',imageList);
        let field1='images1';
        //console.log(imageList[0]['file'].size);
        setFormValues(prevState => ({
        ...prevState,
        [field1]: imageList[0]['file']
        }));
    };

    const onChangeImage2 = (imageList, addUpdateIndex) => {
        setImages2(imageList);
        let field2='images2';
        setFormValues(prevState => ({
        ...prevState,
        [field2]: imageList[0]['file']
        }));
      };

    const onChangeImage3 = (imageList, addUpdateIndex) => {
      setImages3(imageList);
      let field3='images3';
      setFormValues(prevState => ({
      ...prevState,
      [field3]: imageList[0]['file']
      }));
    };

    const onChangeImage4 = (imageList, addUpdateIndex) => {
      setImages4(imageList);
      let field4='images4';
      setFormValues(prevState => ({
      ...prevState,
      [field4]: imageList[0]['file']
      }));
    };

    const onChangeImage5 = (imageList, addUpdateIndex) => {
      setImages5(imageList);
      const field5='images5';
      setFormValues(prevState => ({
      ...prevState,
      [field5]: imageList[0]['file']
      }));
    };*/


    const hanldeUpdateChange = (e,item,index) => {
      
      let editlistarray=[];
      let listarray =list;
      editlistarray = editlist;
      let changeitem = item;
      let key = e.target.name;
      let value = e.target.value;
      
      if(key==='images')
      {
        value=e.target.files[0];
      }
      changeitem[key]=value;
      editlistarray[index] = changeitem;
      listarray[index] = changeitem;
      setList(listarray);
      setEditList(editlistarray);
    }

    const handleUpdateSubmit = (e) => {
        e.preventDefault();
        var formData = new FormData();
        let arrDT=[];
        let arrImg=[];
        let vaimages='';
        let i=0;
        list.forEach(item => {
          formData.append('list[]', item);
          //console.log('check data in list',item.images);
          arrDT.push(item);
          arrImg.push(item.images);
          i++;
        });
        /*let arrImg0='';
        let arrImg1='';
        let arrImg2='';
        let arrImg3='';
        let arrImg4='';
        if(arrImg.length<1){
          arrImg0=arrImg[0];
        } else if(arrImg.length<2){
          arrImg0=arrImg[0];
          arrImg1=arrImg[1];
        } else if(arrImg.length<3){
          arrImg0=arrImg[0];
          arrImg1=arrImg[1];
          arrImg2=arrImg[2];
        } else if(arrImg.length<4){
          arrImg0=arrImg[0];
          arrImg1=arrImg[1];
          arrImg2=arrImg[2];
          arrImg3=arrImg[3];
        } else if(arrImg.length<5){
          arrImg0=arrImg[0];
          arrImg1=arrImg[1];
          arrImg2=arrImg[2];
          arrImg3=arrImg[3];
          arrImg4=arrImg[4];
        }*/
        //console.log('all images',arrImg);
        let dataParams={'inputData' : JSON.stringify(arrDT),'listLength':arrImg.length,'inputImages0':arrImg[0],'inputImages1':arrImg[1],'inputImages2':arrImg[2],'inputImages3':arrImg[3],'inputImages4':arrImg[4],'inputImages5':arrImg[5],'inputImages6':arrImg[6],'inputImages7':arrImg[7],'inputImages8':arrImg[8],'inputImages9':arrImg[9]}
        setLoading(true);
        artworkupdate(dataParams).then(res => handleResponse(res))
    }

    const hanldeChange = (e) => {
      let value=e.target.value;
      let field=e.target.name;
      if(field==='images1' || field==='images2' || field==='images3' || field==='images4' || field==='images5' || field==='images6' || field==='images7' || field==='images8' || field==='images9' || field==='images10')
      {
        value=e.target.files[0];
      }
      setFormValues(prevState => ({
      ...prevState,
      [field]: value }));
    }
    
    const handleSubmit = (e) => {
        e.preventDefault();
        formValues.event_id=event_id;
        const errorCount = validate(formValues);
        setFormErrors(errorCount);
        debugger;
        console.log('check data for formdata',formValues);
        if(errorCount.status){
        setLoading(true);
        artworkCreate(formValues).then(res => handleResponse(res))
        }
    }

    const handleResponse = (response) => {
      if(response.status==200)
      {
        setLoading(false);
        navigation("/termsandconditions/"+event_id);
      }
      else
      {
        setLoading(false);
        navigation('/boothDetails/'+event_id);
      }
    }

    const handleBackSubmit =(e) => {
      navigation('/boothDetails/'+event_id);
    }

    const validate = (values) => 
    {
        const errors = {};
        errors.status = true;
        var error_val=0;
        if(!values.name1){
          errors.name1 = 'Name is Required';
          error_val = 1;
        }

        if(!values.name2){
          errors.name2 = 'Name is Required';
          error_val = 1;
        }

        if(!values.name3){
          errors.name3 = 'Name is Required';
          error_val = 1;
        }

        if(!values.name4){
          errors.name4 = 'Name is Required';
          error_val = 1;
        }

        if(!values.name5){
          errors.name5 = 'Name is Required';
          error_val = 1;
        }

        if(!values.title1){
          errors.title1 = 'Title is Required';
          error_val = 1;
        }

        if(!values.title2){
          errors.title2 = 'Title is Required';
          error_val = 1;
        }

        if(!values.title3){
          errors.title3 = 'Title is Required';
          error_val = 1;
        }

        if(!values.title4){
          errors.title4 = 'Title is Required';
          error_val = 1;
        }

        if(!values.title5){
          errors.title5 = 'Title is Required';
          error_val = 1;
        }

        if(!values.medium1){
          errors.medium1 = 'Medium is Required';
          error_val = 1;
        }

        if(!values.medium2){
          errors.medium2 = 'Medium is Required';
          error_val = 1;
        }

        if(!values.medium3){
          errors.medium3 = 'Medium is Required';
          error_val = 1;
        }

        if(!values.medium4){
          errors.medium4 = 'Medium is Required';
          error_val = 1;
        }

        if(!values.medium5){
          errors.medium5 = 'Medium is Required';
          error_val = 1;
        }

        if(!values.edition1){
          errors.edition1 = 'Edition is Required';
          error_val = 1;
        }

        if(!values.edition2){
          errors.edition2 = 'Edition is Required';
          error_val = 1;
        }

        if(!values.edition3){
          errors.edition3 = 'Edition is Required';
          error_val = 1;
        }

        if(!values.edition4){
          errors.edition4 = 'Edition is Required';
          error_val = 1;
        }

        if(!values.edition5){
          errors.edition5 = 'Edition is Required';
          error_val = 1;
        }

        if(!values.year1){
          errors.year1 = 'Year is Required';
          error_val = 1;
        }

        if(values.year1 && values.year1.length>4){
          errors.year1 = 'Enter valid Year';
          error_val = 1;
        }
        if(values.year1 && values.year1.length<4){
          errors.year1 = 'Enter valid Year';
          error_val = 1;
        }

        if(!values.year2){
          errors.year2 = 'Year is Required';
          error_val = 1;
        }
        
        if(values.year2 && values.year2.length>4){
          errors.year2 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year2 && values.year2.length<4){
          errors.year2 = 'Enter valid Year';
          error_val = 1;
        }

        if(!values.year3){
          errors.year3 = 'Year is Required';
          error_val = 1;
        }
        
        if(values.year3 && values.year3.length>4){
          errors.year3 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year3 && values.year3.length<4){
          errors.year3 = 'Enter valid Year';
          error_val = 1;
        }

        if(!values.year4){
          errors.year4 = 'Year is Required';
          error_val = 1;
        }

        if(values.year4 && values.year4.length>4){
          errors.year4 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year4 && values.year4.length<4){
          errors.year4 = 'Enter valid Year';
          error_val = 1;
        }

        if(!values.year5){
          errors.year5 = 'Year is Required';
          error_val = 1;
        }

        if(values.year5 && values.year5.length>4){
          errors.year5 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year5 && values.year5.length<4){
          errors.year5 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year6 && values.year6.length>4){
          errors.year6 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year6 && values.year6.length<4){
          errors.year6 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year7 && values.year7.length>4){
          errors.year7 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year7 && values.year7.length<4){
          errors.year7 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year8 && values.year8.length>4){
          errors.year8 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year8 && values.year8.length<4){
          errors.year8 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year9 && values.year9.length>4){
          errors.year9 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year9 && values.year9.length<4){
          errors.year9 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year10 && values.year10.length>4){
          errors.year10 = 'Enter valid Year';
          error_val = 1;
        }

        if(values.year10 && values.year10.length<4){
          errors.year10 = 'Enter valid Year';
          error_val = 1;
        }

        if(!values.price1){
          errors.price1 = 'Price is Required';
          error_val = 1;
        }

        if(!values.price2){
          errors.price2 = 'Price is Required';
          error_val = 1;
        }

        if(!values.price3){
          errors.price3 = 'Price is Required';
          error_val = 1;
        }

        if(!values.price4){
          errors.price4 = 'Price is Required';
          error_val = 1;
        }

        if(!values.price5){
          errors.price5 = 'Price is Required';
          error_val = 1;
        }

        if(!values.size_type1){
          errors.size_type1 = 'Size Type Required';
          error_val = 1;
        }

        if(!values.size_type2){
          errors.size_type2 = 'Size Type Required';
          error_val = 1;
        }

        if(!values.size_type3){
          errors.size_type3 = 'Size Type Required';
          error_val = 1;
        }

        if(!values.size_type4){
          errors.size_type4 = 'Size Type Required';
          error_val = 1;
        }

        if(!values.size_type5){
          errors.size_type5 = 'Size Type Required';
          error_val = 1;
        }

        if(!values.height1){
          errors.height1 = 'Height is Required';
          error_val = 1;
        }

        if(!values.height2){
          errors.height2 = 'Height is Required';
          error_val = 1;
        }

        if(!values.height3){
          errors.height3 = 'Height is Required';
          error_val = 1;
        }

        if(!values.height4){
          errors.height4 = 'Height is Required';
          error_val = 1;
        }

        if(!values.height5){
          errors.height5 = 'Height is Required';
          error_val = 1;
        }

        if(!values.width1){
          errors.width1 = 'Width is Required';
          error_val = 1;
        }

        if(!values.width2){
          errors.width2 = 'Width is Required';
          error_val = 1;
        }

        if(!values.width3){
          errors.width3 = 'Width is Required';
          error_val = 1;
        }

        if(!values.width4){
          errors.width4 = 'Width is Required';
          error_val = 1;
        }

        if(!values.width5){
          errors.width5 = 'Width is Required';
          error_val = 1;
        }

        if(!values.images1){
          errors.images1 = 'Images is Required';
          error_val = 1;
        }

        
        if(values.images1 && values.images1.size>=8000000){
          errors.images1 = 'Please upload the images less than 8mb';
          error_val = 1;
        }

        if(!values.images2){
          errors.images2 = 'Images is Required';
          error_val = 1;
        }

        if(values.images2 && values.images2.size>=8000000){
          errors.images2 = 'Please upload the images less than 8mb';
          error_val = 1;
        }

        if(!values.images3){
          errors.images3 = 'Images is Required';
          error_val = 1;
        }

        if(values.images3 && values.images3.size>=8000000){
          errors.images3 = 'Please upload the images less than 8mb';
          error_val = 1;
        }

        if(!values.images4){
          errors.images4 = 'Images is Required';
          error_val = 1;
        }

        if(values.images4 && values.images4.size>=8000000){
          errors.images4 = 'Please upload the images less than 8mb';
          error_val = 1;
        }

        if(!values.images5){
          errors.images5 = 'Images is Required';
          error_val = 1;
        }

        if(values.images5 && values.images5.size>=8000000){
          errors.images5 = 'Please upload the images less than 8mb';
          error_val = 1;
        }

        if(values.images6 && values.images6.size>=8000000){
          errors.images6 = 'Please upload the images less than 8mb';
          error_val = 1;
        }

        if(values.images7 && values.images7.size>=8000000){
          errors.images7 = 'Please upload the images less than 8mb';
          error_val = 1;
        }

        if(values.images8 && values.images8.size>=8000000){
          errors.images8 = 'Please upload the images less than 8mb';
          error_val = 1;
        }

        if(values.images9 && values.images9.size>=8000000){
          errors.images9 = 'Please upload the images less than 8mb';
          error_val = 1;
        }

        if(values.images10 && values.images10.size>=8000000){
          errors.images10 = 'Please upload the images less than 8mb';
          error_val = 1;
        }

        if(error_val===1)
        {
          window.scrollTo(100, 100);
            errors.status=false;
        }
        else
        {
            errors.status=true;
        }
        return errors;
    }


   
    return(
      <>
      <section className="sec-container" >
          <div className='container'>
              <div className='portalevent'>
                <div className='row'>
                  <div className={`col-md-3 portal-sidebar leftbar-close ${sidebar ? 'close' : ''}`}>
                        <div >
                          <Rightbar event_id={event_id}/>
                        </div>
                  </div>
                  <div className={`col-md-9 rightbar-open ${mainbar ? 'open' : ''}`}>
                    <div className='rightbar '>
                          <Button variant="outline-info" onClick={toggle}>
                            <FontAwesomeIcon icon={faAlignLeft} />
                          </Button>
                          <div>
                            <p className='italic_font'>All applications must include at least 5 images with relevant captions, and all images with relevant captions you plan to exhibit. 
                            </p>
                          </div>
                          <h1>Upload Artwork</h1>
                          <div>
                            <p className='red'>File Specifications: jpg, sRGB, 72 dpi, less than or equal to 8MB (300 dpi files will be requested separately if required). 
                            </p>
                            <p className='red'>File names cannot contain any apostrophes or special characters.</p>
                            <p className='red'>Captions should contain title, medium, dimensions, year, etc. </p>
                          </div>
                          <br/>
                          {
                            loading ? <ClipLoader color={color} loading={loading} cssOverride={override} size={250} /> : 
                          <>
                          { list.length ?
                          <Form className='artwork upload-form' onSubmit={handleUpdateSubmit} enctype="multipart/form-data">
                          <ListGroup>
                            {list.map((item,i) => (
                            // <div className="user">{item.name}{i+1}</div>

                              <ListGroup.Item>  
                                <Row className="mb-4" >
                                  <Col md={2}>Artist #{i+1}</Col>
                                  <Col md={10}>
                                    <Row>
                                      <Col md={6}>
                                        <Form.Group controlId="formHorizontalEmail">  
                                        <Form.Label >Name</Form.Label>
                                        <input type="hidden"  className="form-control input-lg" name={"id"} defaultValue={item.id ? item.id : ''}  />

                                        <Form.Control type="text" placeholder="Name" name={"name"}    defaultValue={item.name}  onChange={(e) =>hanldeUpdateChange(e,item,i)} required/> 
                                        <p className="error">{formErrors.name}</p>
                                        </Form.Group>
                                      </Col>
                                      <Col md={6}>
                                        <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Title  </Form.Label>
                                        <Form.Control type="text" placeholder="Title" name={"title"} defaultValue={item.title}  onChange={(e) =>hanldeUpdateChange(e,item,i)} required/> 
                                        <p className="error">{formErrors.title}</p>
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col md={6}>
                                        <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Medium  </Form.Label>
                                        <Form.Control type="text" placeholder="Medium"  name={"medium"} defaultValue={item.medium}  onChange={(e) =>hanldeUpdateChange(e,item,i)} required/> 
                                        </Form.Group>
                                      </Col>
                                      <Col md={6}>
                                        <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Edition  </Form.Label>
                                        <Form.Control type="text" placeholder="Edition" name={"edition"} defaultValue={item.edition}  onChange={(e) =>hanldeUpdateChange(e,item,i)} required/> 
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col md={6}>
                                        <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Year  </Form.Label>
                                        <Form.Control type="number" placeholder="Year" max='4' min='4' name={"year"} defaultValue={item.year}  onChange={(e) =>hanldeUpdateChange(e,item,i)} required/> 
                                        </Form.Group>
                                      </Col>
                                      <Col md={6}>
                                        <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Price USD (numbers only)  </Form.Label>
                                        <Form.Control type="number" placeholder="Price USD (numbers only)" name={"price"} defaultValue={item.price}  onChange={(e) =>hanldeUpdateChange(e,item,i)} required/> 
                                        </Form.Group>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col md={6}>
                                          <Form.Group>
                                            <Form.Label>Size</Form.Label><br />
                                            <Form.Select aria-label="Size" name={"size_type"} value={item.size_type} onChange={(e) =>hanldeUpdateChange(e,item,i)} required>
                                            <option value="" >Select Size</option>
                                            <option value="Inches" >INCHES</option>
                                            <option value="Centimeter">CENTIMETER</option>
                                            </Form.Select>
                                            <p className="error">{formErrors.size_type}</p>
                                          </Form.Group>
                                      </Col>
                                      <Col md={6}>
                                      <Row>
                                        <Col>
                                            <Form.Group controlId="formHorizontalEmail">
                                              <Form.Label > Height  </Form.Label>
                                              <Form.Control type="number" placeholder="in" name={"height"} defaultValue={item.height}  onChange={(e) =>hanldeUpdateChange(e,item,i)} required/>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group  controlId="formHorizontalEmail">
                                              <Form.Label > Width  </Form.Label>
                                              <Form.Control type="number" placeholder="in" name={"width"}  defaultValue={item.width}  onChange={(e) =>hanldeUpdateChange(e,item,i)} required/>
                                            </Form.Group>
                                        </Col>
                                      </Row> 
                                  </Col>
                                </Row>
                                  <Row>
                                    <Col md={12}>
                                      <Form.Group controlId="formHorizontalEmail">
                                      <Form.Label >Select File</Form.Label>
                                        <Form.Control className='artchoose-btn' type="file" placeholder=""  name={"images"} onChange={(e)=>hanldeUpdateChange(e,item,i)}  accept=".png, .jpg, .jpeg, .gif" required/>
                                        {item.images ?
                                        <img src={process.env.REACT_APP_API_STORAGE+item.images} alt="" width="100" /> : ''}
                                      </Form.Group>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row> 
                              </ListGroup.Item>
                            ))}
                          </ListGroup> 
                          <br/>
                          <div className='text-center'>
                            
                              <Button variant="primary" onClick={handleUpdateSubmit} className='common-btn'>Next</Button>{' '}
                              <Button variant="outline-secondary" onClick={handleBackSubmit} className='cancel-btn'>Back</Button>{' '}
                          </div>
                          </Form>
                          : "" }
                          
                        { !list.length ?
                          
                          <Form className='artwork upload-form'>
                          <ListGroup>
                          <div>
                              
                            <ListGroup.Item >  
                              <Row className="mb-4" >
                              <Col md={2}>Artist #1</Col>
                              <Col md={10}>
                                <Row>
                                  <Col md={6}>
                                    <Form.Group controlId="formHorizontalEmail" enctype="multipart/form-data">  
                                    <Form.Label >Name</Form.Label>
                                      <Form.Control type="text" placeholder="Name" name="name1" value={formValues.name1}  onChange={hanldeChange} /> 
                                      <p className="error">{formErrors.name1}</p>
                                    </Form.Group>
                                  </Col>
                                  <Col md={6}>
                                    <Form.Group controlId="formHorizontalEmail">
                                      <Form.Label > Title  </Form.Label>
                                      <Form.Control type="text" placeholder="Title" name="title1" value={formValues.title1}  onChange={hanldeChange} /> 
                                      <p className="error">{formErrors.title1}</p>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={6}>
                                    <Form.Group controlId="formHorizontalEmail">
                                      <Form.Label > Medium  </Form.Label>
                                      <Form.Control type="text" placeholder="Medium"  name="medium1" value={formValues.medium1}  onChange={hanldeChange} /> 
                                      <p className="error">{formErrors.medium1}</p>
                                    </Form.Group>
                                  </Col>
                                  <Col md={6}>
                                    <Form.Group controlId="formHorizontalEmail">
                                      <Form.Label > Edition  </Form.Label>
                                      <Form.Control type="text" placeholder="Edition" name="edition1" value={formValues.edition1}  onChange={hanldeChange} /> 
                                      <p className="error">{formErrors.edition1}</p>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={6}>
                                    <Form.Group controlId="formHorizontalEmail">
                                      <Form.Label > Year  </Form.Label>
                                      <Form.Control type="number" placeholder="Year" name="year1" value={formValues.year1}  onChange={hanldeChange} /> 
                                      <p className="error">{formErrors.year1}</p>
                                    </Form.Group>
                                  </Col>
                                  <Col md={6}>
                                    <Form.Group controlId="formHorizontalEmail">
                                      <Form.Label > Price USD (numbers only)  </Form.Label>
                                      <Form.Control type="number" placeholder="Price USD (numbers only)" name="price1" value={formValues.price1}  onChange={hanldeChange} /> 
                                      <p className="error">{formErrors.price1}</p>
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={6}>
                                      <Form.Group>
                                        <Form.Label>Size</Form.Label><br />
                                        <Form.Select aria-label="Size" name="size_type1" value={formValues.size_type1} onChange={hanldeChange}>
                                          <option value="">Select Size</option>
                                          <option value="Inches">INCHES</option>
                                          <option value="Centimeter">CENTIMETER</option>
                                        </Form.Select>
                                        <p className="error">{formErrors.size_type1}</p>
                                      </Form.Group>
                                  </Col>
                                  <Col md={6}>
                                  <Row>
                                    <Col>
                                        <Form.Group controlId="formHorizontalEmail">
                                          <Form.Label > Height  </Form.Label>
                                          <Form.Control type="number" placeholder="in" name="height1" value={formValues.height1}  onChange={hanldeChange} />
                                          <p className="error">{formErrors.height1}</p>
                                        </Form.Group>
                                        </Col>
                                        <Col>
                                        <Form.Group  controlId="formHorizontalEmail">
                                          <Form.Label > Width  </Form.Label>
                                          <Form.Control type="number" placeholder="in" name="width1" value={formValues.width1}  onChange={hanldeChange} />
                                          <p className="error">{formErrors.width1}</p>
                                        </Form.Group>
                                        </Col>
                                        </Row> 
                                    </Col>
                                </Row>
                                <Row>
                                  <Col md={12}>
                                    <Form.Group controlId="formHorizontalEmail">
                                      <Form.Label >Select File</Form.Label>
                                      <Form.Control className='artchoose-btn' type="file" placeholder=""  name="images1" accept=".png, .jpg, .jpeg, .gif" onChange={hanldeChange}  />
                                      <p className="error">{formErrors.images1}</p>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </Col>
                              </Row> 
                            </ListGroup.Item>

                            <ListGroup.Item>  
                              <Row className="mb-4" >
                              <Col md={2}>Artist #2</Col>
                                <Col md={10}>
                                  <Row>
                                    <Col md={6}>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label >Name</Form.Label>
                                        <Form.Control type="text" placeholder="" name="name2" defaultValue={formValues.name2}  onChange={hanldeChange} /> 
                                        <p className="error">{formErrors.name2}</p>
                                      </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Title  </Form.Label>
                                        <Form.Control type="text" placeholder="" name="title2" defaultValue={formValues.title2}  onChange={hanldeChange} /> 
                                        <p className="error">{formErrors.title2}</p>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={6}>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Medium  </Form.Label>
                                        <Form.Control type="text" placeholder="Medium"  name="medium2" defaultValue={formValues.medium2}  onChange={hanldeChange} /> 
                                        <p className="error">{formErrors.medium2}</p>
                                      </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Edition  </Form.Label>
                                        <Form.Control type="text" placeholder="Edition" name="edition2" defaultValue={formValues.edition2}  onChange={hanldeChange} /> 
                                        <p className="error">{formErrors.edition2}</p>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={6}>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Year  </Form.Label>
                                        <Form.Control type="number" placeholder="Year" name="year2" defaultValue={formValues.year2}   onChange={hanldeChange} /> 
                                        <p className="error">{formErrors.year2}</p>
                                      </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Price USD (numbers only)  </Form.Label>
                                        <Form.Control type="number" placeholder="Price USD (numbers only)" name="price2" defaultValue={formValues.price2}  onChange={hanldeChange} /> 
                                        <p className="error">{formErrors.price2}</p>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                  <Row>
                                    <Col md={6}>
                                        <Form.Group>
                                          <Form.Label>Size</Form.Label><br />
                                          <Form.Select aria-label="Size" name="size_type2" defalutValue={formValues.size_type2} onChange={hanldeChange}>
                                            <option value="" >Select Size</option>
                                            <option value="Inches" >INCHES</option>
                                            <option value="Centimeter"  >CENTIMETER</option>
                                          </Form.Select>
                                          <p className="error">{formErrors.size_type2}</p>
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                    <Row>
                                      <Col>
                                          <Form.Group controlId="formHorizontalEmail">
                                            <Form.Label > Height  </Form.Label>
                                            <Form.Control type="number" placeholder="in" name="height2" defaultValue={formValues.height2}  onChange={hanldeChange} />
                                            <p className="error">{formErrors.height2}</p>
                                          </Form.Group>
                                          </Col>
                                          <Col>
                                          <Form.Group  controlId="formHorizontalEmail">
                                            <Form.Label > Width  </Form.Label>
                                            <Form.Control type="number" placeholder="in" name="width2" defaultValue={formValues.width2}  onChange={hanldeChange} />
                                            <p className="error">{formErrors.width2}</p>
                                          </Form.Group>
                                          </Col>
                                          </Row> 
                                      </Col>
                                  </Row>
                                  <Row>
                                    <Col md={12}>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label >Select File</Form.Label>
                                        <Form.Control className='artchoose-btn' type="file"  name="images2" accept=".png, .jpg, .jpeg, .gif"   onChange={hanldeChange}  />
                                        <p className="error">{formErrors.images2}</p>
                                      </Form.Group>
                                    </Col>
                                    
                                  </Row>
                                </Col>
                              </Row> 
                            </ListGroup.Item>

                            <ListGroup.Item>  
                            <Row className="mb-4" >
                            <Col md={2}>Artist #3</Col>
                            <Col md={10}>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label >Name</Form.Label>
                                  <Form.Control type="text" placeholder="Name" name="name3" defaultValue={formValues.name3}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.name3}</p>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Title  </Form.Label>
                                  <Form.Control type="text" placeholder="Title" name="title3" defaultValue={formValues.title3}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.title3}</p>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Medium  </Form.Label>
                                  <Form.Control type="text" placeholder="Medium"  name="medium3" defaultValue={formValues.medium3}  onChange={hanldeChange} />
                                  <p className="error">{formErrors.medium3}</p> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Edition  </Form.Label>
                                  <Form.Control type="text" placeholder="Edition" name="edition3" defaultValue={formValues.edition3}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.edition3}</p> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Year  </Form.Label>
                                  <Form.Control type="number" placeholder="Year" name="year3" defaultValue={formValues.year3}  onChange={hanldeChange} />
                                  <p className="error">{formErrors.year3}</p> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Price USD (numbers only)  </Form.Label>
                                  <Form.Control type="number" placeholder="Price USD (numbers only)" name="price3" defaultValue={formValues.price3}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.price3}</p> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                    <Form.Group>
                                      <Form.Label>Size</Form.Label><br />
                                      <Form.Select aria-label="Size" name="size_type3" defalutValue={formValues.size_type3} onChange={hanldeChange}>
                                        <option value="" >Select Size</option>
                                        <option value="Inches" >INCHES</option>
                                        <option value="Centimeter"  >CENTIMETER</option>
                                      </Form.Select>
                                      <p className="error">{formErrors.size_type3}</p>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                <Row>
                                  <Col>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Height  </Form.Label>
                                        <Form.Control type="number" placeholder="Height" name="height3" defaultValue={formValues.height3}  onChange={hanldeChange} />
                                        <p className="error">{formErrors.height3}</p>
                                      </Form.Group>
                                      </Col>
                                      <Col>
                                      <Form.Group  controlId="formHorizontalEmail">
                                        <Form.Label > Width  </Form.Label>
                                        <Form.Control type="number" placeholder="Width" name="width3" defaultValue={formValues.width3}  onChange={hanldeChange} />
                                        <p className="error">{formErrors.width3}</p>
                                      </Form.Group>
                                      </Col>
                                      </Row> 
                                  </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <Form.Group controlId="formHorizontalEmail">
                                    <Form.Label >Select File</Form.Label>
                                    <Form.Control className='artchoose-btn' type="file" placeholder=""  accept=".png, .jpg, .jpeg, .gif" name="images3" defaultValue={formValues.images3}  onChange={hanldeChange}  />
                                    <p className="error">{formErrors.images3}</p> 
                                  </Form.Group>
                                </Col>
                                
                              </Row>

                            </Col>
                            </Row> 
                            </ListGroup.Item>

                            <ListGroup.Item>  
                            <Row className="mb-4" >
                            <Col md={2}>Artist #4</Col>
                            <Col md={10}>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label >Name</Form.Label>
                                  <Form.Control type="text" placeholder="Name" name="name4" defaultValue={formValues.name4}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.name4}</p>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Title  </Form.Label>
                                  <Form.Control type="text" placeholder="Title" name="title4" defaultValue={formValues.title4}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.title4}</p>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Medium  </Form.Label>
                                  <Form.Control type="text" placeholder="Medium"  name="medium4" defaultValue={formValues.medium4}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.medium4}</p>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Edition  </Form.Label>
                                  <Form.Control type="text" placeholder="Edition" name="edition4" defaultValue={formValues.edition4}  onChange={hanldeChange} />
                                  <p className="error">{formErrors.edition4}</p> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Year  </Form.Label>
                                  <Form.Control type="number" placeholder="Year" name="year4" defaultValue={formValues.year4}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.year4}</p> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Price USD (numbers only)  </Form.Label>
                                  <Form.Control type="number" placeholder="Price USD (numbers only)" name="price4" defaultValue={formValues.price4}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.price4}</p> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                    <Form.Group>
                                      <Form.Label>Size</Form.Label><br />
                                      <Form.Select aria-label="Size" name="size_type4" defalutValue={formValues.size_type4} onChange={hanldeChange}>
                                        <option value="">Select Size</option>
                                        <option value="Inches">INCHES</option>
                                        <option value="Centimeter">CENTIMETER</option>
                                      </Form.Select>
                                      <p className="error">{formErrors.size_type4}</p>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                <Row>
                                  <Col>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Height  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="height4" defaultValue={formValues.height4}  onChange={hanldeChange} />
                                        <p className="error">{formErrors.height4}</p>
                                      </Form.Group>
                                      </Col>
                                      <Col>
                                      <Form.Group  controlId="formHorizontalEmail">
                                        <Form.Label > Width  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="width4" defaultValue={formValues.width4}  onChange={hanldeChange} />
                                        <p className="error">{formErrors.width4}</p>
                                      </Form.Group>
                                      </Col>
                                      </Row> 
                                  </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <Form.Group controlId="formHorizontalEmail">
                                    <Form.Label >Select File</Form.Label>
                                    <Form.Control className='artchoose-btn' type="file" placeholder=""  accept=".png, .jpg, .jpeg, .gif" name="images4" defaultValue={formValues.images4}  onChange={hanldeChange}  />
                                    <p className="error">{formErrors.images4}</p> 
                                  </Form.Group>
                                </Col>
                              </Row>
                            </Col>
                            </Row> 
                            </ListGroup.Item>

                            <ListGroup.Item>  
                            <Row className="mb-4" >
                            <Col md={2}>Artist #5</Col>
                            <Col md={10}>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label >Name</Form.Label>
                                  <Form.Control type="text" placeholder="Name" name="name5" defaultValue={formValues.name5}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.name5}</p>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Title  </Form.Label>
                                  <Form.Control type="text" placeholder="Title" name="title5" defaultValue={formValues.title5}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.title5}</p>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Medium  </Form.Label>
                                  <Form.Control type="text" placeholder="Medium"  name="medium5" defaultValue={formValues.medium5}  onChange={hanldeChange} />
                                  <p className="error">{formErrors.medium5}</p> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Edition  </Form.Label>
                                  <Form.Control type="text" placeholder="Edition" name="edition5" defaultValue={formValues.edition5}  onChange={hanldeChange} />
                                  <p className="error">{formErrors.edition5}</p>  
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Year  </Form.Label>
                                  <Form.Control type="number" placeholder="Year" name="year5" defaultValue={formValues.year5}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.year5}</p>  
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Price USD (numbers only)  </Form.Label>
                                  <Form.Control type="number" placeholder="Price USD (numbers only)" name="price5" defaultValue={formValues.price5}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.price5}</p>  
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                    <Form.Group>
                                      <Form.Label>Size</Form.Label><br />
                                      <Form.Select aria-label="Size" name="size_type5" defalutValue={formValues.size_type5} onChange={hanldeChange}>
                                        <option value="">Select Size</option>
                                        <option value="Inches">INCHES</option>
                                        <option value="Centimeter">CENTIMETER</option>
                                      </Form.Select>
                                      <p className="error">{formErrors.size_type5}</p>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                <Row>
                                  <Col>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Height  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="height5" defaultValue={formValues.height5}  onChange={hanldeChange} />
                                        <p className="error">{formErrors.height5}</p>
                                      </Form.Group>
                                      </Col>
                                      <Col>
                                      <Form.Group  controlId="formHorizontalEmail">
                                        <Form.Label > Width  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="width5" defaultValue={formValues.width5}  onChange={hanldeChange} />
                                        <p className="error">{formErrors.width5}</p>
                                      </Form.Group>
                                      </Col>
                                      </Row> 
                                  </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <Form.Group controlId="formHorizontalEmail">
                                    <Form.Label >Select File</Form.Label>
                                    <Form.Control className='artchoose-btn' type="file" placeholder="" accept=".png, .jpg, .jpeg, .gif" name="images5" defaultValue={formValues.images5}   data-max-size="100" onChange={hanldeChange}  />
                                    <p className="error">{formErrors.images5}</p> 
                                  </Form.Group>
                                </Col>
                                
                              </Row>

                            </Col>
                            </Row> 
                            </ListGroup.Item>

                            <ListGroup.Item>  
                            <Row className="mb-4" >
                            <Col md={2}>Artist #6</Col>
                            <Col md={10}>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label >Name</Form.Label>
                                  <Form.Control type="text" placeholder="Name" name="name6" defaultValue={formValues.name6}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.name6}</p>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Title  </Form.Label>
                                  <Form.Control type="text" placeholder="Title" name="title6" defaultValue={formValues.title6}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.title6}</p>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Medium  </Form.Label>
                                  <Form.Control type="text" placeholder="Medium"  name="medium6" defaultValue={formValues.medium6}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Edition  </Form.Label>
                                  <Form.Control type="text" placeholder="Edition" name="edition6" defaultValue={formValues.edition6}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Year  </Form.Label>
                                  <Form.Control type="number" placeholder="Year" name="year6" defaultValue={formValues.year6}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Price USD (numbers only)  </Form.Label>
                                  <Form.Control type="number" placeholder="Price USD (numbers only)" name="price6" defaultValue={formValues.price6}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                    <Form.Group>
                                      <Form.Label>Size</Form.Label><br />
                                      <Form.Select aria-label="Size" name="size_type6" defalutValue={formValues.size_type6} onChange={hanldeChange}>
                                        <option value="">Select Size</option>
                                        <option value="Inches">INCHES</option>
                                        <option value="Centimeter">CENTIMETER</option>
                                      </Form.Select>
                                      <p className="error">{formErrors.size_type}</p>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                <Row>
                                  <Col>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Height  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="height6" defaultValue={formValues.height6}  onChange={hanldeChange} />
                                      </Form.Group>
                                      </Col>
                                      <Col>
                                      <Form.Group  controlId="formHorizontalEmail">
                                        <Form.Label > Width  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="width6" defaultValue={formValues.width6}  onChange={hanldeChange} />
                                      </Form.Group>
                                      </Col>
                                      </Row> 
                                  </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <Form.Group controlId="formHorizontalEmail">
                                    <Form.Label >Select File</Form.Label>
                                    <Form.Control className='artchoose-btn' type="file" placeholder="" accept=".png, .jpg, .jpeg, .gif" name="images6" defaultValue={formValues.images6}   data-max-size="100" onChange={hanldeChange}  />
                                    <p className="error">{formErrors.images6}</p> 
                                  </Form.Group>
                                </Col>
                                
                              </Row>

                            </Col>
                            </Row> 
                            </ListGroup.Item>

                            <ListGroup.Item>  
                            <Row className="mb-4" >
                            <Col md={2}>Artist #7</Col>
                            <Col md={10}>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label >Name</Form.Label>
                                  <Form.Control type="text" placeholder="Name" name="name7" defaultValue={formValues.name7}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.name7}</p>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Title  </Form.Label>
                                  <Form.Control type="text" placeholder="Title" name="title7" defaultValue={formValues.title7}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.title7}</p>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Medium  </Form.Label>
                                  <Form.Control type="text" placeholder="Medium"  name="medium7" defaultValue={formValues.medium7}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Edition  </Form.Label>
                                  <Form.Control type="text" placeholder="Edition" name="edition7" defaultValue={formValues.edition7}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Year  </Form.Label>
                                  <Form.Control type="number" placeholder="Year" name="year7" defaultValue={formValues.year7}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Price USD (numbers only)  </Form.Label>
                                  <Form.Control type="number" placeholder="Price USD (numbers only)" name="price7" defaultValue={formValues.price7}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                    <Form.Group>
                                      <Form.Label>Size</Form.Label><br />
                                      <Form.Select aria-label="Size" name="size_type7" defalutValue={formValues.size_type7} onChange={hanldeChange}>
                                        <option value="">Select Size</option>
                                        <option value="Inches">INCHES</option>
                                        <option value="Centimeter">CENTIMETER</option>
                                      </Form.Select>
                                      <p className="error">{formErrors.size_type}</p>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                <Row>
                                  <Col>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Height  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="height7" defaultValue={formValues.height7}  onChange={hanldeChange} />
                                      </Form.Group>
                                      </Col>
                                      <Col>
                                      <Form.Group  controlId="formHorizontalEmail">
                                        <Form.Label > Width  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="width7" defaultValue={formValues.width7}  onChange={hanldeChange} />
                                      </Form.Group>
                                      </Col>
                                      </Row> 
                                  </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <Form.Group controlId="formHorizontalEmail">
                                    <Form.Label >Select File</Form.Label>
                                    <Form.Control className='artchoose-btn' type="file" placeholder="" accept=".png, .jpg, .jpeg, .gif" name="images7" defaultValue={formValues.images7}   data-max-size="100" onChange={hanldeChange}  />
                                    <p className="error">{formErrors.images7}</p> 
                                  </Form.Group>
                                </Col>
                                
                              </Row>

                            </Col>
                            </Row> 
                            </ListGroup.Item>

                            <ListGroup.Item>  
                            <Row className="mb-4" >
                            <Col md={2}>Artist #8</Col>
                            <Col md={10}>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label >Name</Form.Label>
                                  <Form.Control type="text" placeholder="Name" name="name8" defaultValue={formValues.name8}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.name8}</p>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Title  </Form.Label>
                                  <Form.Control type="text" placeholder="Title" name="title8" defaultValue={formValues.title8}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.title8}</p>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Medium  </Form.Label>
                                  <Form.Control type="text" placeholder="Medium"  name="medium8" defaultValue={formValues.medium8}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Edition  </Form.Label>
                                  <Form.Control type="text" placeholder="Edition" name="edition8" defaultValue={formValues.edition8}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Year  </Form.Label>
                                  <Form.Control type="number" placeholder="Year" name="year8" defaultValue={formValues.year8}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Price USD (numbers only)  </Form.Label>
                                  <Form.Control type="number" placeholder="Price USD (numbers only)" name="price8" defaultValue={formValues.price8}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                    <Form.Group>
                                      <Form.Label>Size</Form.Label><br />
                                      <Form.Select aria-label="Size" name="size_type8" defalutValue={formValues.size_type8} onChange={hanldeChange}>
                                        <option value="">Select Size</option>
                                        <option value="Inches">INCHES</option>
                                        <option value="Centimeter">CENTIMETER</option>
                                      </Form.Select>
                                      <p className="error">{formErrors.size_type}</p>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                <Row>
                                  <Col>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Height  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="height8" defaultValue={formValues.height8}  onChange={hanldeChange} />
                                      </Form.Group>
                                      </Col>
                                      <Col>
                                      <Form.Group  controlId="formHorizontalEmail">
                                        <Form.Label > Width  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="width8" defaultValue={formValues.width8}  onChange={hanldeChange} />
                                      </Form.Group>
                                      </Col>
                                      </Row> 
                                  </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <Form.Group controlId="formHorizontalEmail">
                                    <Form.Label >Select File</Form.Label>
                                    <Form.Control className='artchoose-btn' type="file" placeholder="" accept=".png, .jpg, .jpeg, .gif" name="images8" defaultValue={formValues.images8}   data-max-size="100" onChange={hanldeChange}  />
                                    <p className="error">{formErrors.images8}</p> 
                                  </Form.Group>
                                </Col>
                                
                              </Row>

                            </Col>
                            </Row> 
                            </ListGroup.Item>

                            <ListGroup.Item>  
                            <Row className="mb-4" >
                            <Col md={2}>Artist #9</Col>
                            <Col md={10}>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label >Name</Form.Label>
                                  <Form.Control type="text" placeholder="Name" name="name9" defaultValue={formValues.name9}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.name9}</p>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Title  </Form.Label>
                                  <Form.Control type="text" placeholder="Title" name="title9" defaultValue={formValues.title9}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.title9}</p>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Medium  </Form.Label>
                                  <Form.Control type="text" placeholder="Medium"  name="medium9" defaultValue={formValues.medium9}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Edition  </Form.Label>
                                  <Form.Control type="text" placeholder="Edition" name="edition9" defaultValue={formValues.edition9}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Year  </Form.Label>
                                  <Form.Control type="number" placeholder="Year" name="year9" defaultValue={formValues.year9}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Price USD (numbers only)  </Form.Label>
                                  <Form.Control type="number" placeholder="Price USD (numbers only)" name="price9" defaultValue={formValues.price9}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                    <Form.Group>
                                      <Form.Label>Size</Form.Label><br />
                                      <Form.Select aria-label="Size" name="size_type9" defalutValue={formValues.size_type9} onChange={hanldeChange}>
                                        <option value="">Select Size</option>
                                        <option value="Inches">INCHES</option>
                                        <option value="Centimeter">CENTIMETER</option>
                                      </Form.Select>
                                      <p className="error">{formErrors.size_type}</p>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                <Row>
                                  <Col>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Height  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="height9" defaultValue={formValues.height9}  onChange={hanldeChange} />
                                      </Form.Group>
                                      </Col>
                                      <Col>
                                      <Form.Group  controlId="formHorizontalEmail">
                                        <Form.Label > Width  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="width9" defaultValue={formValues.width9}  onChange={hanldeChange} />
                                      </Form.Group>
                                      </Col>
                                      </Row> 
                                  </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <Form.Group controlId="formHorizontalEmail">
                                    <Form.Label >Select File</Form.Label>
                                    <Form.Control className='artchoose-btn' type="file" placeholder="" accept=".png, .jpg, .jpeg, .gif" name="images9" defaultValue={formValues.images9}   data-max-size="100" onChange={hanldeChange}  />
                                    <p className="error">{formErrors.images9}</p> 
                                  </Form.Group>
                                </Col>
                                
                              </Row>

                            </Col>
                            </Row> 
                            </ListGroup.Item>

                            <ListGroup.Item>  
                            <Row className="mb-4" >
                            <Col md={2}>Artist #10</Col>
                            <Col md={10}>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label >Name</Form.Label>
                                  <Form.Control type="text" placeholder="Name" name="name10" defaultValue={formValues.name10}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.name10}</p>
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Title  </Form.Label>
                                  <Form.Control type="text" placeholder="Title" name="title10" defaultValue={formValues.title10}  onChange={hanldeChange} /> 
                                  <p className="error">{formErrors.title10}</p>
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Medium  </Form.Label>
                                  <Form.Control type="text" placeholder="Medium"  name="medium10" defaultValue={formValues.medium10}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Edition  </Form.Label>
                                  <Form.Control type="text" placeholder="Edition" name="edition10" defaultValue={formValues.edition10}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Year  </Form.Label>
                                  <Form.Control type="number" placeholder="Year" name="year10" defaultValue={formValues.year10}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                                <Col md={6}>
                                  <Form.Group controlId="formHorizontalEmail">
                                  <Form.Label > Price USD (numbers only)  </Form.Label>
                                  <Form.Control type="number" placeholder="Price USD (numbers only)" name="price10" defaultValue={formValues.price10}  onChange={hanldeChange} /> 
                                  </Form.Group>
                                </Col>
                              </Row>
                              <Row>
                                <Col md={6}>
                                    <Form.Group>
                                      <Form.Label>Size</Form.Label><br />
                                      <Form.Select aria-label="Size" name="size_type10" defalutValue={formValues.size_type10} onChange={hanldeChange}>
                                        <option value="">Select Size</option>
                                        <option value="Inches">INCHES</option>
                                        <option value="Centimeter">CENTIMETER</option>
                                      </Form.Select>
                                      <p className="error">{formErrors.size_type10}</p>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                <Row>
                                  <Col>
                                      <Form.Group controlId="formHorizontalEmail">
                                        <Form.Label > Height  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="height10" defaultValue={formValues.height10}  onChange={hanldeChange} />
                                      </Form.Group>
                                      </Col>
                                      <Col>
                                      <Form.Group  controlId="formHorizontalEmail">
                                        <Form.Label > Width  </Form.Label>
                                        <Form.Control type="number" placeholder="in" name="width10" defaultValue={formValues.width10}  onChange={hanldeChange} />
                                      </Form.Group>
                                      </Col>
                                      </Row> 
                                  </Col>
                              </Row>
                              <Row>
                                <Col md={12}>
                                  <Form.Group controlId="formHorizontalEmail">
                                    <Form.Label >Select File</Form.Label>
                                    <Form.Control className='artchoose-btn' type="file" placeholder="" accept=".png, .jpg, .jpeg, .gif" name="images10" defaultValue={formValues.images10}   data-max-size="100" onChange={hanldeChange}  />
                                    <p className="error">{formErrors.images10}</p> 
                                  </Form.Group>
                                </Col>
                                
                              </Row>

                            </Col>
                            </Row> 
                            </ListGroup.Item>
                          </div>


                          {/* //////////////// create end //// */}

                          
                          </ListGroup> 
                          <br/>
                          <div className='text-center'>
                          <Button variant="primary" onClick={handleSubmit} className='common-btn'>Next</Button>{' '}
                          <Button variant="outline-secondary" onClick={handleBackSubmit} className='cancel-btn'>Back</Button>{' '}
                          </div>
                          </Form> : "" }
                          </>
                        }
                    </div>
                  </div>
                </div>
              </div>
          </div>
      </section>
      </>
    )
}